import { defineStore } from "pinia";

interface State {
  defaultSectionAttributes: {
    "full-width": string;
    padding: string;
    "mj-class": string;
    "in-group"?: boolean;
  };
}

export const useDefaultsStore = defineStore("defaults", {
  state: (): State => ({
    defaultSectionAttributes: {
      "full-width": "full-width",
      padding: "10px 0px 10px 0px",
      "mj-class": "section",
    },
  }),
  actions: {
    setDefaultSectionInGroup(stuckColumns: boolean) {
      this.defaultSectionAttributes["in-group"] = !stuckColumns;
    },
  },
});
